
// ────────────────────────────────────────────────
// MFA Setup Form (QR + OTP)
// ────────────────────────────────────────────────
function MfaSetupForm({
  qrCode, secret,
  otp, setOtp,
  loading, onSubmit, onSkip
}) {
  return (
    <div>
      {qrCode ? (
        <img
          src={qrCode}
          alt="MFA QR Code"
          style={{ width: '200px', display: 'block', margin: '0 auto 16px auto' }}
        />
      ) : (
        <p style={{ textAlign: 'center' }}>Loading QR code...</p>
      )}

      {secret && (
        <p style={{ fontSize: '14px', textAlign: 'center', margin: '16px 0' }}>
          Or enter manually: <strong>{secret}</strong>
        </p>
      )}

      <form onSubmit={onSubmit}>
        <input
          type="text"
          value={otp}
          onChange={(e) => setOtp(e.target.value.replace(/\D/g, '').slice(0, 6))}
          placeholder="Enter 6-digit code"
          maxLength={6}
          disabled={loading}
          style={{
            width: '100%',
            padding: '14px',
            fontSize: '22px',
            textAlign: 'center',
            letterSpacing: '8px',
            border: '1px solid #ccc',
            borderRadius: '8px',
            marginBottom: '16px',
          }}
        />

        <button
          type="submit"
          disabled={loading}
          style={{
            width: '100%',
            padding: '14px',
            background: loading ? '#aaa' : '#1976d2',
            color: 'white',
            border: 'none',
            borderRadius: '6px',
            fontSize: '17px',
            marginBottom: '12px',
            cursor: loading ? 'not-allowed' : 'pointer',
          }}
        >
          {loading ? 'Verifying...' : 'Enable MFA'}
        </button>
      </form>

      <button
        onClick={onSkip}
        style={{
          width: '100%',
          padding: '11px',
          background: 'transparent',
          color: '#666',
          border: '1px solid #ccc',
          borderRadius: '6px',
          cursor: 'pointer',
        }}
      >
        Skip for now
      </button>
    </div>
  );
}

export default MfaSetupForm;